import * as React from "react";
const SvgRightArrow = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 5.3 7" {...props}><path d="M5.3 3.5.4.6.3 6.4z" style={{
    fill: "#c5c5c5"
  }} /></svg>;
export { SvgRightArrow as ReactComponent };